import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './services/spinner.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ProgressSpinnerModule, CommonModule, ToastModule, ConfirmDialogModule],
    templateUrl: './app.html',
    styleUrl: './app.scss',
    standalone: true
})
export class App {

    public spinnerSvc = inject(SpinnerService);

}
